module.exports = __webpack_public_path__ + "img/absorbente6.1977e579.jpg";